import { createStore } from '@souche-f2e/muji';
import { generatePdf, downloadPdf } from '../services/pdf';
import { message } from 'antd';

const state = {
  pdfUrl: ''
}

export default createStore({
  state,
  reducers: {
    UPDATE_STATE(state, payload) {
      return {
        ...state,
        ...payload
      }
    }
  },
  effects: {
    updatePath(payload, { state, rootState }) { 
      this.UPDATE_STATE(payload)
    },
    async generatePdf(id) {
      const body = await generatePdf(id).promise;
      const { success, data } = body;
  
      if(success) {
        this.UPDATE_STATE({
          pdfUrl: data.filename.split('/').slice(-1)[0]
        });
      } else {
        message.error(`生成失败${data}`);
      }
    },
  }
});